const y = (l, d, h, e) => {
  const t = {
    quantity: 1,
    selectedShipping: null,
    productVariant: null
  }, a = (c) => l((u) => ({
    ...u,
    physicalProduct: { ...u.physicalProduct, ...c }
  }));
  return {
    quantity: (e == null ? void 0 : e.quantity) ?? t.quantity,
    setQuantity: (c) => a({ quantity: c }),
    selectedShipping: (e == null ? void 0 : e.selectedShipping) ?? t.selectedShipping,
    setSelectedShipping: (c) => a({ selectedShipping: c }),
    productVariant: (e == null ? void 0 : e.productVariant) ?? t.productVariant,
    setProductVariant: (c) => a({ productVariant: c })
  };
};
export {
  y as createPhysicalProductSlice
};
